export default __webpack_public_path__ + "static/media/game@3x.70aaafc4.png";